import { Col, Form, message, Row } from "antd"
import { NJVButton, NJVInput, NJVSelect } from '../../components/core-component'
import Theme from "../../components/theme"
import { NumberOnly } from "../../core/validator"
import Api from "../../network/api"
import { ApiHandlerNoAuth } from "../../network/network-manager"
import { HTTP_METHOD } from "../../network/httpMethod"
import { MEDIA_TYPE } from "../../network/mediaType"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import CustomPath from "../../routes/custom-path"
const PublicSubmitTicket = () => {

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const submitRequestSupport = (formData) => {
        setLoading(true)
        ApiHandlerNoAuth({ url: Api.public_ticket_submission, method: HTTP_METHOD.POST, mediaType: MEDIA_TYPE.JSON, requestData: formData, disableShowMessage: true })
            .then(response => {
                message.success("Thank you! Your request has been submitted successfully. Our team will review it and get back to you shortly.")
                setLoading(false)
                navigate(CustomPath.login)
            })
            .catch(error => { })
    }

    return (<>
        <Row style={{ marginTop: 20 }}>
            <Col lg={3} md={1} xs={1} sm={1} />
            <Col lg={18} md={22} xs={22} sm={22}>
                <Form onFinish={submitRequestSupport} style={{ marginTop: 10 }}>
                    <Row gutter={[16, 16]}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                            <span style={{ fontSize: 18, fontWeight: '500' }}> Submit a Support Request or Complaint Ticket</span>
                        </Col>
                        <Col span={24} style={{ textAlign: 'center' }}>
                            <span style={{ fontSize: 16, fontWeight: '400' }}>
                                Whether you need support or want to report an issue, please fill out the form below. Our team will get back to you as soon as possible.
                            </span>
                        </Col>
                        <Col lg={8} md={8} xs={24} sm={24}>
                            <Form.Item name="fullName" rules={[{ required: true }]}>
                                <NJVInput size="large" placeholder="Enter full name" />
                            </Form.Item>
                        </Col>
                        <Col lg={8} md={8} xs={24} sm={24}>
                            <Form.Item name="emailAddress" rules={[{ required: true }]}>
                                <NJVInput size="large" placeholder="Enter email address" />
                            </Form.Item>
                        </Col>
                        <Col lg={8} md={8} xs={24} sm={24}>
                            <Form.Item name="phoneNumber" rules={[{ required: true, validator: NumberOnly }]}>
                                <NJVInput size="large" placeholder="Enter phone number" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="submission" rules={[{ required: true }]}>
                                <NJVSelect
                                    size="large"
                                    style={{
                                        width: '100%'
                                    }}
                                    // selectborder="#E6EFF5"
                                    // selectprimary="#E6EFF5"
                                    placeholder="Type of submission"
                                    options={[
                                        {
                                            'key': 1,
                                            'label': 'Request Support',
                                            'value': 'Request Support'
                                        }, {
                                            'key': 2,
                                            'label': 'Submit Complaint',
                                            'value': 'Submit Complaint'
                                        }
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="subject" rules={[{ required: true }]}>
                                <NJVInput size="large" placeholder="Enter subject" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="content" rules={[{ required: true }]}>
                                <NJVInput istextareainput={true} size="large" placeholder="Enter content" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="category" rules={[{ required: true }]}>
                                <NJVSelect
                                    size="large"
                                    style={{
                                        width: '100%'
                                    }}
                                    // selectborder="#E6EFF5"
                                    // selectprimary="#E6EFF5"
                                    placeholder="Select category"
                                    options={[
                                        {
                                            'key': 1,
                                            'label': 'Technical Support',
                                            'value': 'Technical Support'
                                        }, {
                                            'key': 2,
                                            'label': 'Billing Issue',
                                            'value': 'Billing Issue'
                                        }, {
                                            'key': 3,
                                            'label': 'Account Help',
                                            'value': 'Account Help'
                                        }, {
                                            'key': 4,
                                            'label': 'General Inquiry',
                                            'value': 'General Inquiry'
                                        }, {
                                            'key': 5,
                                            'label': 'Other',
                                            'value': 'Other'
                                        }
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24} style={{ textAlign: 'center' }}>
                            Note : Please provide as much detail as possible to help us assist you better. We aim to respond within 24-48 hours.
                        </Col>
                        <Col span={24} style={{ textAlign: 'center', marginBottom: 100 }}>
                            <NJVButton buttonprimary={Theme.colors.primary} type="primary" htmlType="submit" loading={loading}>Submit Request</NJVButton>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>

    </>)
}
export default PublicSubmitTicket